import TwToast from './TwToast.vue';
import TwToastContainer from './TwToastContainer.vue';
import toastService from './toastService';

/**
 * TwToastPlugin — Vue plugin that:
 * 1. Mounts TwToastContainer as a body-appended singleton (outside the main app tree,
 *    so it works before and after Vue mounts)
 * 2. Exposes Vue.prototype.$notify for use in all Vue components
 *
 * Usage:
 *   this.$notify('Message text', 'success')
 *   this.$notify({ title: 'Payment Recorded', message: 'Payment processed.', type: 'success' })
 *   this.$notify({ title: 'Warning', message: 'Something needs attention.', type: 'warning', duration: 0 })
 */
export const TwToastPlugin = {
  install(Vue) {
    // Mount the container as a standalone Vue instance appended to <body>.
    // This is intentionally outside the main app tree so it can receive
    // notifications queued before the app mounts (e.g. Twig flash messages).
    const ContainerClass = Vue.extend(TwToastContainer);
    const instance = new ContainerClass().$mount();
    document.body.appendChild(instance.$el);

    // Vue prototype method — available as this.$notify() in all components
    Vue.prototype.$notify = function (optsOrMessage, type) {
      toastService.add(optsOrMessage, type);
    };
  },
};

// Default export is the TwToast component so the ui-library.js auto-scan
// (which looks for index.js files) registers it as a global component correctly.
export default TwToast;
export { TwToast, TwToastContainer };
